import { render, staticRenderFns } from "./ViewProductDesign.vue?vue&type=template&id=481c4157&scoped=true"
import script from "./ViewProductDesign.vue?vue&type=script&lang=js"
export * from "./ViewProductDesign.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./ViewProductDesign.vue?vue&type=style&index=0&id=481c4157&prod&scoped=true&lang=css")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "481c4157",
  null
  ,true
)

export default component.exports